// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"363":"38bb33b8","432":"bcc655b8","737":"d88c25f4"}[chunkId] + ".chunk.js";
};